/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Card, SearchIcon, SpinnerIcon } from '@avila-tek/ui/src';
import { useLazyQuery } from '@apollo/client';
import { Company } from '../../../../models';
import { SMALL_GET_COMPANY } from '../../../../graphql/queries';
import {
  ACTIONS as ACTIONS_COMPANY,
  ACTIONS_TYPE as ACTIONS_TYPE_COMPANY,
} from './reducer';
import {
  ACTIONS as ACTIONS_ADDRESS,
  ACTIONS_TYPE as ACTIONS_TYPE_ADDRESS,
} from '../AddressForm/reducer';
import FormHeader, { FormHeaderProps } from '../FormHeader';
import Alert from '../../Alert/Alert';

interface SearchCompanyProps {
  header: FormHeaderProps;
  companyDispatch: React.Dispatch<ACTIONS_TYPE_COMPANY>;
  addressDispatch: React.Dispatch<ACTIONS_TYPE_ADDRESS>;
  setCompanyReadOnly: React.Dispatch<React.SetStateAction<boolean>>;
  setAddressReadOnly: React.Dispatch<React.SetStateAction<boolean>>;
}

function SearchCompany({
  header,
  companyDispatch,
  addressDispatch,
  setCompanyReadOnly,
  setAddressReadOnly,
}: SearchCompanyProps) {
  const [text, setText] = React.useState<string>('');
  const [noCompany, setNoCompany] = React.useState<boolean>(false);

  const [getCompany, { loading, data: companyData }] = useLazyQuery<{
    company: Company;
  }>(SMALL_GET_COMPANY, {
    fetchPolicy: 'cache-and-network',
  });

  const searchCompany = async () => {
    const { data } = await getCompany({ variables: { filter: { dni: text } } });
    if (data?.company?._id) {
      companyDispatch({
        type: ACTIONS_COMPANY.DEFAULT,
        payload: { ...data.company },
      });
      addressDispatch({
        type: ACTIONS_ADDRESS.DEFAULT,
        payload: { ...data.company?.addresses[0] },
      });
      setNoCompany(false);
      setAddressReadOnly(true);
      setCompanyReadOnly(true);
    } else {
      setNoCompany(true);
      companyDispatch({ type: ACTIONS_COMPANY.DEFAULT, payload: {} });
      addressDispatch({
        type: ACTIONS_ADDRESS.DEFAULT,
        payload: {},
      });
    }
  };

  const onTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
    setText(e.target.value);
  };

  return (
    <Card>
      <FormHeader title={header?.title ?? ''} />
      <Card.Body>
        <div className="w-full flex flex-wrap md:flex-nowrap gap-5">
          <div className="w-full md:w-1/2 ">
            <Alert
              title="Encuentra tu compañia ingresando el RIF"
              text="Aplica para compañia que ya se encuentren registradas como aliadas o sus trabajadores gocen de nuestros beneficios."
              show
            />
          </div>
          <div className="w-full md:w-1/2  flex flex-col justify-center items-center ">
            <label
              className="w-full flex justify-between border  border-neutral-300 bg-white px-3 py-1 rounded h-10 items-center text-gray-700"
              htmlFor="client"
            >
              <input
                id="client"
                name="client"
                placeholder="Ingrese el número de RIF"
                className="w-full rounded focus:outline-none focus-within:ring-0 text-gray-700 text-sm "
                value={text}
                onChange={onTextChange}
              />
              {loading ? (
                <SpinnerIcon className="w-5 h-5 text-gray-200 animate-spin fill-white" />
              ) : (
                <button id="enter-button" onClick={searchCompany} type="submit">
                  <SearchIcon className="h-5 w-5" />
                </button>
              )}
            </label>
            {noCompany ? (
              <span className="text-sm text-danger-200">
                No se ha encontrado compañia con ese RIF
              </span>
            ) : null}
            {companyData && !noCompany ? (
              <span className="text-sm text-success-200">
                Se ha encontrado compañia en Meit
              </span>
            ) : null}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}

export default SearchCompany;
